function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as r } from "./index.es33.js";
import { useMemo as c } from "react";
import { clsx as h } from "./index.es105.js";
import { Typography as l } from "./index.es35.js";
import "./index.es36.js";
import "./index.es133.js";
import "react-dom";
import "./index.es134.js";
import { TimeZoneDate as x } from "./index.es506.js";
import { years as d, months as j, showTextMap as f, compareMap as u } from "./index.es634.js";
import e from "./index.es635.js";
var Y = function Y(_ref) {
  var _ref$type = _ref.type,
    o = _ref$type === void 0 ? "months" : _ref$type,
    _ref$date = _ref.date,
    m = _ref$date === void 0 ? new x() : _ref$date,
    i = _ref.onSelect;
  var a = c(function () {
      return {
        years: d(m),
        months: j
      }[o];
    }, [o, m]) || [],
    n = f[o],
    p = u[o];
  return r.jsx("div", {
    className: e.wrapper,
    children: r.jsx("table", {
      children: r.jsx("tbody", {
        children: a.map(function (s) {
          return r.jsx("tr", {
            children: (s || []).rows.map(function (t) {
              return r.jsx("td", {
                className: e.calendarMonthYearPickerItem,
                children: r.jsx(l.Body2, {
                  as: "button",
                  className: h(e.itemButton, _defineProperty({}, e.selectedItem, p(t, m))),
                  onClick: function onClick() {
                    return i === null || i === void 0 ? void 0 : i(t);
                  },
                  children: n(t)
                })
              }, t.toString());
            })
          }, s.key);
        })
      })
    })
  });
};
export { Y as MonthYearPicker };